exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.land-signature-pad[data-v-3072ab49] {\n  border: 1px solid salmon;\n  border-radius: 25px;\n  max-width: 400px;\n}\n.canvas-box[data-v-3072ab49] {\n  border-radius: 25px;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  min-height: 120px;\n}\n.font-size-li[data-v-3072ab49]{\n  font-size: 18px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-3072ab49","scoped":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/professional/contract/ProfessionalContractIDCard.vue
// module id = 1935
// module chunks = 0